import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=5589337e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5589337e')) {
      api.createRecord('5589337e', component.options)
    } else {
      api.reload('5589337e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=5589337e&", function () {
      api.rerender('5589337e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bcd0yu2ryi1i/JS/videoIframe.vue"
export default component.exports